import React from 'react';
import styles from './ProfileSection.module.css';

const classNames = require('classnames');

export default function ProfileSection({ section, children, label, hideCategoryLabel = false }) {

  return (
    <div id={section} key={section} className={classNames(styles.section, 'overflow-auto')}>
      {!hideCategoryLabel && <div className={classNames(styles.header, 'pb-4')}>{label || section.split('_').join(' ')}</div>}
      {children}
    </div>
  )
}
